import { Bounds, Vector } from '@ardoq/graph';
import { rectHeight, rectWidth } from 'tabview/visualizations/misc/geometry';
import { Projection } from '../projection';
import { BlocksNode } from '../types';
import { renderNode } from './node';
import { createRenderContext } from './rendercontext';
import { RenderParameters } from './types';

export const getDragImage = (proj: Projection, node: BlocksNode) => {
  const offscreenCanvas = () => {
    const rc = proj.projectBounds(node.bounds);
    const sz: Vector = [rectWidth(rc), rectHeight(rc)];

    const scale = 1; // Math.max(...sz) / 1024; // TODO scale down and take the hit in rendering quality

    return new OffscreenCanvas(sz[0] * scale, sz[1] * scale);
  };

  const world = node.bounds;
  const canvas = offscreenCanvas();
  const viewport: Bounds = [0, 0, canvas.width, canvas.height];
  const projection = new Projection();

  projection.adjustToViewport(viewport, 1);
  projection.adjustToBounds(world, 0);

  const params: RenderParameters = {
    ctx: canvas.getContext('2d')!,
    projection: projection,
    isLowlight: false,
    isReadonly: true,
    prefersReducedMotion: true,
  };

  const context = createRenderContext(params);

  const doit = (node: BlocksNode) => {
    if (node.cell) {
      renderNode(node, node.cell, 1, context);
    }

    if (node.children) {
      for (const child of node.children) {
        doit(child);
      }
    }
  };

  doit(node);

  return canvas;
};
